import { render, staticRenderFns } from "./HistoryDialog.vue?vue&type=template&id=646d7752&scoped=true"
import script from "./HistoryDialog.vue?vue&type=script&lang=js"
export * from "./HistoryDialog.vue?vue&type=script&lang=js"
import style0 from "./HistoryDialog.vue?vue&type=style&index=0&id=646d7752&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646d7752",
  null
  
)

export default component.exports